<template>
<div>
    <!-- CSS Global Compulsory -->
    <link rel="stylesheet" href="../../static/assets/bootstrap/css/bootstrap.min.css">
    <link rel="stylesheet" href="../../static/assets/css/style.css">

    <!-- CSS Header and Footer -->
    <link rel="stylesheet" href="../../static/assets/css/header.css">
    <link rel="stylesheet" href="../../static/assets/css/footer.css">
  <div>
      <router-link to="/"><img style="position: absolute;z-index:2;left: 4%;top: 2%;height: 55px;" src="../../static/assets/img/headerlogo.png"/></router-link>
      <!-- <router-link to="/contactUs"><div style="position: absolute;z-index:2;right: 10%;top: 4%;height: 55px;color: white;font-size: 17px;">联系我们</div></router-link> -->
      <!-- <div style="position: absolute;z-index:2;left: 20%;top: 45%;color: white;font-size: 45px;font-weight: 400;">塔兮</div>
      <div style="position: absolute;z-index:2;left: 20%;top: 60%;color: white;font-size: 30px;font-weight: 300;">知识分享和技能交易平台<br>All In One生活的提倡者</div> -->
      <img style="position: absolute;z-index:2;left: 30%;top: 50%;height: 130px;"  src="../../static/assets/img/headerslogan.png"/>
    <video-player  class="video-player vjs-custom-skin"
                   ref="videoPlayer"
                   :playsinline="true"
                   :options="playerOptions">
    </video-player>
  </div>
  <div class="container content">

    <!-- Info Blokcs -->
    <div class="row margin-bottom-60">
        <!-- Welcome Block -->
        <div class="col-md-6">
            <h2>塔兮APP</h2>
            <div style="font-weight:300">Tower X APP</div>
            <div class="row margin-top-20 margin-bottom-20">

                <div class="col-md-9">
                    <p style="font-size:16px;margin-top: 50px;">每一个塔兮点滴都是建造未来的基石</p>
                    <p style="font-size:16px;margin-bottom: 100px;">因为塔兮,所以简单</p>
                    <div class="col-md-6">
                      <div class="thumbnails thumbnail-style">
                          <img class="img-responsive" src="../../static/assets/img/iosxz.png" alt="" />
                          <div class="caption">
                              <h3 class="hover-effect" style="position:center;">iOS下载</h3>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-6">
                      <div class="thumbnails thumbnail-style">
                          <img class="img-responsive" src="../../static/assets/img/androidxz.png" alt="" />
                          <div class="caption">
                              <h3 class="hover-effect">安卓下载</h3>
                          </div>
                      </div>
                  </div>
                </div>
            </div>

        </div><!--/col-md-8-->

        <!-- Latest Shots -->

        <div class="col-md-3">
            <img class="img-responsive margin-bottom-20" src="../../static/assets/img/tx.png" alt="">
        </div>
        <div class="col-md-3">
            <img class="img-responsive margin-bottom-20" src="../../static/assets/img/tx2.png" alt="">
        </div>
        <!--/col-md-4-->
    </div><!--/row-->
    <!-- End Info Blokcs -->


    <!-- Info Blokcs -->
    <div class="row margin-bottom-20">
        <!-- Welcome Block -->
        <div class="col-md-8 ">
            <h2>关于塔兮</h2>
            <div style="font-weight:300">About Us</div>
            <div class="row margin-top-20">
                <div class="col-sm-4">
                    <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txbb.png" alt="">
                </div>
                <div class="col-sm-8">
                    <p style="font-size:16px">塔兮是一款泛技能社交平台,用户可以通过塔兮发布随意秀来展现自我风采;发布课程合集来分享技能知识;同时塔兮也是一款技能需求和供给的双向共享平台,用户可以通过技能展示和技能需求来完成技能交易.</p>

                    <div class="col-md-3 btn-buy animated fadeInRight margin-top-40" style="margin-top: 60px;">
                        <router-link to="/txinfo" class="btn-u btn-u-lg" style="background:rgb(38, 104, 233); ">查看详情</router-link>
                    </div>
                </div>
            </div>

        </div><!--/col-md-8-->

        <!-- Latest Shots -->
        <div class="col-md-4 md-margin-bottom-20">
            <img class="img-responsive margin-bottom-20" src="../../static/assets/img/txzm.png" alt="">

        </div><!--/col-md-4-->
    </div><!--/row-->
    <!-- End Info Blokcs -->

  </div>

  <div class="container-fluid">
      <div class="row no-gutter">
          <div class="col-sm-4 sm-margin-bottom-30">
            <span>
              <img class="img-responsive" src="../../static/assets/img/footer1.png" alt="">
              <div style="position: absolute;z-index:3;width: 100%;height: 100%;top:0%; white;background: rgba(10, 10, 10, 0.2);"/>
              <div style="position: absolute;z-index:4;left: 12%;top: 60%;color: white;font-size: 30px;font-weight: 400;">娱乐</div>
              <div style="position: absolute;z-index:4;left: 12%;top: 75%;color: white;font-size: 16px;font-weight: 300;">日常所见所闻的生活娱乐秀;<br>秀出生活,秀出自己,成为塔兮明星达人</div>
            </span>
          </div>
          <div class="col-sm-4 sm-margin-bottom-30">
            <span>
              <img class="img-responsive" src="../../static/assets/img/footer2.png" alt="">
              <div style="position: absolute;z-index:3;width: 100%;height: 100%;top:0%; white;background: rgba(10, 10, 10, 0.2);"/>
              <div style="position: absolute;z-index:4;left: 12%;top: 60%;color: white;font-size: 30px;font-weight: 400;">社交</div>
              <div style="position: absolute;z-index:4;left: 12%;top: 75%;color: white;font-size: 16px;font-weight: 300;">建立或者加入自己擅长或者喜欢的塔圈群;<br>以"技"会友,打造自己独有的高质量社交圈</div>
            </span>
          </div>
          <div class="col-sm-4 sm-margin-bottom-30">
            <span>
              <img class="img-responsive" src="../../static/assets/img/footer3.png" alt="">
              <div style="position: absolute;z-index:3;width: 100%;height: 100%;top:0%; white;background: rgba(10, 10, 10, 0.2);"/>
              <div style="position: absolute;z-index:4;left: 12%;top: 60%;color: white;font-size: 30px;font-weight: 400;">个人生活笔记</div>
              <div style="position: absolute;z-index:4;left: 12%;top: 75%;color: white;font-size: 16px;font-weight: 300;">记录个人生活成长的时间轴,私人定制塔兮回忆录</div>
            </span>
          </div>
      </div>
  </div>

  <div class="container-fluid">
      <div class="row no-gutter">
          <div class="col-sm-4 sm-margin-bottom-30">
            <span>
              <img class="img-responsive" src="../../static/assets/img/footer4.png" alt="">
              <div style="position: absolute;z-index:3;width: 100%;height: 100%;top:0%; white;background: rgba(10, 10, 10, 0.2);"/>
              <div style="position: absolute;z-index:4;left: 12%;top: 60%;color: white;font-size: 30px;font-weight: 400;">学习</div>
              <div style="position: absolute;z-index:4;left: 12%;top: 75%;color: white;font-size: 16px;font-weight: 300;">优秀达人视频课程教学,简单,方便随看随学</div>
            </span>
          </div>
          <div class="col-sm-4 sm-margin-bottom-30">
            <span>
              <img class="img-responsive" src="../../static/assets/img/footer5.png" alt="">
              <div style="position: absolute;z-index:3;width: 100%;height: 100%;top:0%; white;background: rgba(10, 10, 10, 0.2);"/>
              <div style="position: absolute;z-index:4;left: 12%;top: 60%;color: white;font-size: 30px;font-weight: 400;">技能变现</div>
              <div style="position: absolute;z-index:4;left: 12%;top: 75%;color: white;font-size: 16px;font-weight: 300;">秀出自身技能特长,售卖技能特长及服务</div>
            </span>
          </div>
          <div class="col-sm-4 sm-margin-bottom-30">
            <span>
              <img class="img-responsive" src="../../static/assets/img/footer6.png" alt="">
              <div style="position: absolute;z-index:3;width: 100%;height: 100%;top:0%; white;background: rgba(10, 10, 10, 0.2);"/>
              <div style="position: absolute;z-index:4;left: 12%;top: 60%;color: white;font-size: 30px;font-weight: 400;">求助</div>
              <div style="position: absolute;z-index:4;left: 12%;top: 75%;color: white;font-size: 16px;font-weight: 300;">遇事一键求助,召集牛人来帮忙</div>
            </span>
          </div>
      </div>
  </div>

  <div style="width: 100%;">
      <router-link to="/partner">
            <span><img class="img-responsive" src="../../static/assets/img/xzhhr.png" alt=""></span></router-link>
  </div>

  <!-- <div class="footer-v1">
      <div class="copyright">
          <div class="container">
            <div class="col">
                      <p>
                          <router-link to="/protocol" style="color: rgb(38, 104, 233);">软件协议</router-link>
                          <router-link to="/policy" style="color: rgb(38, 104, 233);">隐私协议</router-link>
                      </p>
                      <p>
                          2019 &copy; 武汉云上塔兮信息技术有限公司 版权所有 鄂ICP备 18014986号-1
                      </p>
            </div>

          </div>
      </div>
  </div>     -->
   <div class="footer-v1">
        <div class="footer">
            <div class="container">
                <div class="row">
                    <!-- About -->
                    <div class="col-md-2">
                      <img class="img-responsive " src="../../static/assets/img/txzmtm.png" alt="">
                    </div><!--/col-md-3-->
                    <!-- End About -->
                    <!-- Latest -->
                    <div class="col-md-4 md-margin-bottom-40">
                        <div class="posts">
                            <div class="headline"><h2>备案信息</h2></div>
                            <ul class="list-unstyled latest-list">
                                <li>
                                  <a href="../../static/privacy.html" style="color: rgb(38, 104, 233);">隐私协议</a>
                                </li>
                                <li>
                                  <a href="../../static/protocol.html" style="color: rgb(38, 104, 233);">用户服务协议</a>
                                </li>
                                <li>
                                  <a href="../../static/tort.html" style="color: rgb(38, 104, 233);">侵权投诉指引</a>
                                </li>
                                <li style="color:white">
                                  <a href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备 18014986号-1</a><br>2019 &copy; 武汉云上塔兮信息技术有限公司 版权所有
                                </li>
                            </ul>
                        </div>

                        <a href="https://xyt.xcc.cn/getpcInfo?sn=1573218083571380224&language=CN&certType=8&url=*.towerxi.com" target="_blank" style="position: relative;display: inline-block;height: 38px;">
<div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div><embed src="https://program.xinchacha.com/web/1573218083571380224=*.towerxi.com.svg"width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/></a>

                    </div><!--/col-md-3-->
                    <!-- End Latest -->

                    <!-- Address -->
                    <div class="col-md-4 map-img ">
                        <div class="headline"><h2>联系我们</h2></div>
                        <address class="md-margin-bottom-40">
                            地址：湖北省武汉市洪山区珞喻路618号东方怡景大厦B座<br>
                            电话：027-88515977<br>
                            Email: <a href="mailto:towerx@towerxi.cn" style="color:rgb(38, 104, 233); ">towerx@towerxi.cn</a>
                        </address>
                    </div><!--/col-md-3-->
                    <!-- End Address -->
                </div>
            </div>
        </div><!--/footer-->


    </div>
      
</div>
</template>
<script>


export default {
    name:'Main',
    data () {
      return {
          // 视频播放
          playerOptions : {
              // playbackRates : [ 0.5, 1.0, 1.5, 2.0 ], //可选择的播放速度
              autoplay : true, //如果true,浏览器准备好时开始回放。
              muted : true, // 默认情况下将会消除任何音频。
              loop : true, // 视频一结束就重新开始。
              preload : 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
              language : 'zh-CN',
                fluid : true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
              sources : [ {
                  type : "",
                  src : '../../static/video.mp4'//url地址
              } ],
              width: document.documentElement.clientWidth,

              controls:false
          }
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Main.vue